import { Button, Checkbox, Col, Form, Input, Modal, Row, Select, Space, theme } from "antd"
import React, { useEffect, useState } from "react";
import { PASSWORD_DEFAULT, requiredItem, ROLE_PERMISSION, TYPE_MODAL } from "../../../constants/constants";
import { consoleLogUtil } from "../../../utils/consoleLogUtil";
import { filterOption } from "../../../utils/funcHelper";

const ModalAddAndEdit = ({ visible, onCancel, onSave, data, title, type, lstDepartment, lstRoles, lstShops }) => {
    const [form] = Form.useForm();
    const { token } = theme.useToken();
    const [isStaff, setIsStaff] = useState(false);
    consoleLogUtil("data", data);
    const formStyle = {
        maxWidth: 'none',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
    };
    const handleFinish = (values) => {
        console.log(values);
        const tiktokShops = values.shops ? values.shops?.map(item => ({ shop_id: item})) : [];
        if (type === TYPE_MODAL.ADD) {
            onSave({
                ...values,
                shops: [...tiktokShops],
            });
        } else {
            let tempData = { ...values };
            if (values.password === PASSWORD_DEFAULT) {
                delete tempData.password;
            }
            tempData.id = data.id;
            tempData.shops = [...tiktokShops];
            onSave(tempData);
        }
    };

    const handleChangeRoleSupplier = (values) => {
        if (values.includes('2')) { //Nhóm quyền nhân viên
            setIsStaff(true);
        } else {
            setIsStaff(false);
        }
    }
    const handleChangeDepartment = (values) => {
        
    }

    useEffect(() => {
        if (type === TYPE_MODAL.EDIT) {
            form.setFieldsValue({
                username: data.username,
                fullname: data.fullname,
                password: PASSWORD_DEFAULT,
                departments: data.departments.map(item => item.id),
                roles: data.roles.map(item => item.id),
            });
            
            if (data.roles.map(item => item.id).includes(ROLE_PERMISSION.STAFF)) {
                setIsStaff(true);
                form.setFieldsValue({
                    shops: data?.shops?.map(item => item.id)
                });
            }
        } else {
            form.resetFields();
        }
    }, [data, type, visible]);

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={onCancel}
            width={'80%'}
            footer={null}
        >
            <Form form={form} layout="vertical" name="add-edit-account" style={formStyle} onFinish={handleFinish}>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            label="Tên tài khoản"
                            name="username"
                            rules={requiredItem}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Họ và tên"
                            name="fullname"
                            rules={requiredItem}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Mật khẩu"
                            name="password"
                            rules={requiredItem}
                        >
                            <Input type="password" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            label="Phòng ban"
                            name="departments"
                            rules={requiredItem}
                        >
                            <Select
                                mode="multiple"
                                style={{ width: '100%', height: 40 }}
                                placeholder="Chọn phòng ban"
                                maxTagCount={'responsive'}
                                options={lstDepartment}
                                onChange={handleChangeDepartment}
                            />
                        </Form.Item>
                    </Col>
                    {
                        isStaff ?
                            <>
                                <Col span={8}>
                                    <Form.Item
                                        label="Tiktok Shops"
                                        name="shops"
                                    >
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            style={{ width: '100%', height: 40 }}
                                            placeholder="Chọn shop"
                                            maxTagCount={'responsive'}
                                            filterOption={filterOption}
                                            options={lstShops}
                                            onChange={(value) => {
                                                consoleLogUtil(value);
                                            }
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </>

                            :
                            null
                    }
                    <Col span={8}>
                        <Form.Item
                            label="Quyền"
                            name="roles"
                            rules={requiredItem}
                        >
                            <Checkbox.Group options={lstRoles} onChange={handleChangeRoleSupplier} />
                        </Form.Item>
                    </Col>

                </Row>
                <Row gutter={16} justify={'end'}>
                    <Space>
                        <Button onClick={onCancel}>
                            Hủy
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Lưu
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Modal>
    )
}
export default React.memo(ModalAddAndEdit);